export const redirectStores = [
  {
    ownerId: "4b8fae3f31b5e0c6c80ccf8814f9caadd98c03f5",
    redirectPath: "https://bitualhairspa.com/",
  },
  {
    ownerId: "27a4c1b8ceea34e2ce395920207457a1da66b0e9",
    redirectPath: "https://finemyauto.com/",
  }
];

export const getRedirectStore = (redirect: string, storeMetadataOwnerId: string) => {
  const store = redirectStores.find((store) => store.ownerId === storeMetadataOwnerId);
  return store ? store.redirectPath : redirect;
};
